exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-slide .video-img{position:absolute;top:0;right:0;z-index:1}.video-slide .play-icon{cursor:pointer;position:absolute;top:50%;left:50%;z-index:9;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.video-slide--initiated .video-img{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31aa7263","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/YoutubeSlide.vue
// module id = tOCl
// module chunks = 0